import type { PieArcDatum } from 'd3-shape';
import type { ProvidedProps } from '@visx/shape/lib/shapes/Pie';

import type { Datum } from '../types';

import {
  LABEL_HEIGHT,
  OUTER_RADIUS,
  OTHERS_LABEL,
  OTHERS_LABEL_BUFFER_ZONE,
} from '../constants';

type Position = 'left' | 'right';

export const getPosition = (x: number): Position => (x < 0 ? 'left' : 'right');

export const collisionTest = ({
  position,
  thisY,
  lastY,
}: {
  position: Position;
  thisY: number;
  lastY: number;
}) => {
  if (position === 'right' && thisY - LABEL_HEIGHT < lastY) {
    return false;
  }

  if (position === 'left' && thisY + LABEL_HEIGHT > lastY) {
    return false;
  }

  if (position === 'left' && thisY - LABEL_HEIGHT < OTHERS_LABEL_BUFFER_ZONE) {
    return false;
  }

  return true;
};

type Args = {
  thisArc: PieArcDatum<Datum>;
  pie: ProvidedProps<Datum>;
  lastArc?: PieArcDatum<Datum>;
};

export const labelCollisionTest = ({ thisArc, lastArc, pie }: Args) => {
  if (thisArc.index === 0) return true;
  if (thisArc.data.label === OTHERS_LABEL) return true;
  if (typeof lastArc === 'undefined') return true;

  pie.path.outerRadius(OUTER_RADIUS + 80);

  const [thisX, thisY] = pie.path.centroid(thisArc);
  const [lastX, lastY] = pie.path.centroid(lastArc);

  const positionA = getPosition(thisX);
  const positionB = getPosition(lastX);

  if (positionA !== positionB) return true;

  return collisionTest({
    position: positionA,
    thisY,
    lastY,
  });
};
